export default __webpack_public_path__ + "static/Floorplan_for download_Townhouse-f463a98d05e665e8013ea64e4e00eb54.pdf";